module.exports = {"title":"Display","ipAddress":"IP Address","code":"Code","macAddress":"MAC Address","mac":"MAC Address","license":"License","room":"Room","status":"Status","model":"Model","turnOn":"Turn On","turnOff":"Turn Off","create":"Create Display","update":"Update Display","view":"View Display","turnonSuccess":"Turn on display success","turnoffSuccess":"Turn off display success","lock":"Lock","unlock":"Unlock","lockSuccess":"Lock display success","unlockSuccess":"Unlock display success"}


//////////////////
// WEBPACK FOOTER
// ./src/language/en/display.json
// module id = 1010
// module chunks = 10